import React from "react"

const Icon = ({ primary = "#1A1B43", secondary = "url(#paint0_linear_1659_3016)" }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.9957 9.08984C16.5457 9.08984 16.9957 9.53984 16.9957 10.0898L16.9957 21.0898C16.9957 21.6398 16.5457 22.0898 15.9957 22.0898C15.4457 22.0898 14.9957 21.6398 14.9957 21.0898L14.9957 10.0898C14.9957 9.53984 15.4457 9.08984 15.9957 9.08984Z"
      fill={secondary}
    />
    <path
      d="M6 30C4.35 30 3 28.66 3 27V23C3 22.45 3.45 22 4 22C4.55 22 5 22.45 5 23V27C5 27.55 5.45 28 6 28H26.01C26.56 28 27.01 27.55 27.01 27V23C27.01 22.45 27.46 22 28.01 22C28.56 22 29.01 22.45 29.01 23V27C29.01 28.65 27.67 30 26.01 30H6Z"
      fill={primary}
    />
    <path
      d="M16.1457 2C16.3857 2 16.6257 2.09 16.8157 2.26L24.6657 9.35C24.9757 9.63 25.0757 10.07 24.9257 10.45C24.7757 10.84 24.4057 11.09 23.9957 11.09L20.9957 11.09L20.9957 25.09C20.9957 25.64 20.5457 26.09 19.9957 26.09C19.4457 26.09 18.9957 25.64 18.9957 25.09L18.9957 10.09C18.9957 9.54 19.4457 9.09 19.9957 9.09H21.3957L16.1357 4.33L10.6757 9.09H12.0057C12.5557 9.09 13.0057 9.54 13.0057 10.09V17.09C13.0057 17.64 12.5557 18.09 12.0057 18.09C11.4557 18.09 11.0057 17.64 11.0057 17.09V11.09L8.00573 11.09C7.58573 11.09 7.21573 10.83 7.06573 10.44C6.91573 10.05 7.03573 9.61 7.34573 9.34L15.4957 2.25C15.6857 2.09 15.9157 2 16.1557 2L16.1457 2Z"
      fill={primary}
    />
    <defs>
      <linearGradient
        id="paint0_linear_1659_3016"
        x1="14.9957"
        y1="22.0898"
        x2="14.9957"
        y2="9.08984"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FD9317" />
        <stop offset="1" stopColor="#F63B3B" />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon
